import React from "react";
import PublicDistributionStaff from "components/Tvendo/Distribution/DataMaster/PublicDistributionStaff/List";

export default function () {
  return <PublicDistributionStaff />;
}
